module.exports = __webpack_public_path__ + "static/hr_capabilities_6-0b1023d471f30d1c8518f5d9b6c97af4.png";